module.exports = __webpack_public_path__ + "img/48.2c3191bd.jpg";